import pick from "lodash/fp/pick";
import DialogFunctions from "../../../core/dialogFunctions";

const MAX_SEATS = {
  car: 20,
  bus: 72,
};
class AddBustypeDialogController extends DialogFunctions {
  constructor($mdDialog, $injector, Events) {
    "ngInject";
    super($mdDialog);
    this.City = $injector.get("City");
    this.BusType = $injector.get("Bustype");
    this.Events = Events;

    this.vehicleTypeResponse = null;
    this.vehicleTypes = [];
    this.vehicleMakes = [];
    this.vehicleModel = [];
    this.maxSeats = MAX_SEATS.car;
    this.rideCategoriesEvent = this.Events.getUpdateEvent("selectRideCategory");
    this.vehicleTypeEvent = this.Events.getUpdateEvent("selectVehicleType");
  }

  $onInit() {
    this.Events.on(this.vehicleTypeEvent, this.onSelectVehicleType.bind(this));
    this.getRideCategories();

    this.BusType.getVehicleTypes().$promise.then((response) => {
      this.vehicleTypeResponse = response;
      const _vehicleTypes = pick(["bus", "car"])(response);

      if (_vehicleTypes) {
        this.vehicleTypes = Object.keys(_vehicleTypes).map((key) => ({
          title: key,
          name: key,
        }));
      }
    });
  }

  onSelectVehicleType(type) {
    const _vehicleMakes = this.vehicleTypeResponse[type];
    this.vehicleMakes = Object.keys(_vehicleMakes).map((key) => ({
      title: key,
      name: key,
    }));

    if (type === "car") {
      this.maxSeats = MAX_SEATS.car;
      this.model.maxSeats = MAX_SEATS.car;
    } else if (type === "bus") {
      this.maxSeats = MAX_SEATS.bus;
      this.model.maxSeats = MAX_SEATS.bus;
    }

    if (this.model.make) this.onSelectVehicleMake(this.model.make);
  }

  onSelectVehicleMake(make) {
    const _vehicleModels = this.vehicleTypeResponse[this.model.vehicleType][
      make
    ];

    this.vehicleModel = _vehicleModels.map((key) => ({
      title: key,
      name: key,
    }));
  }

  getRideCategories() {
    this.City.getRideCategory().$promise.then((response) => {
      if (response.hits) {
        this.rideCategoryList = response.hits.map((item) => ({
          name: item._id,
          title: `${item._source.service_type} (${item._source.ride_type})`,
        }));
      }
    });
  }
}

export default AddBustypeDialogController;



// WEBPACK FOOTER //
// ./src/pages/bustypes/addBustypeDialog/addBustypeDialog.controller.js